import rowOptionsTemplate from './rowOptionsTemplate.html'
import _module from 'module.js'

_module.directive('rowOptions', function () {
  return {
    restrict: 'A',
    template: rowOptionsTemplate
  }
})
